// Box highlighter
class Highlighter {
  constructor(containerElement) {
    this.container = containerElement;
    this.boxes = Array.from(this.container.children);
    this.mouse = {
      x: 0,
      y: 0,
    };
    this.containerSize = {
      w: 0,
      h: 0,
    };
    this.boxPositions = [];
    this.raf = null;
    this.initContainer = this.initContainer.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.updateBoxStyles = this.updateBoxStyles.bind(this);
    this.init();
  }

  initContainer() {
    // Batch all DOM reads together
    this.containerSize.w = this.container.offsetWidth;
    this.containerSize.h = this.container.offsetHeight;
    
    // Cache box positions relative to container
    const containerRect = this.container.getBoundingClientRect();
    this.boxPositions = this.boxes.map(box => {
      const boxRect = box.getBoundingClientRect();
      return {
        box: box,
        offsetX: boxRect.left - containerRect.left,
        offsetY: boxRect.top - containerRect.top
      };
    });
  }

  updateBoxStyles() {
    // Batch all DOM writes together
    this.boxPositions.forEach(({ box, offsetX, offsetY }) => {
      const boxX = -offsetX + this.mouse.x;
      const boxY = -offsetY + this.mouse.y;
      box.style.setProperty("--mouse-x", `${boxX}px`);
      box.style.setProperty("--mouse-y", `${boxY}px`);
    });
    this.raf = null;
  }

  onMouseMove(event) {
    const { clientX, clientY } = event;
    const rect = this.container.getBoundingClientRect();
    const { w, h } = this.containerSize;
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    const inside = x < w && x > 0 && y < h && y > 0;
    if (inside) {
      this.mouse.x = x;
      this.mouse.y = y;
      
      // Use requestAnimationFrame to batch DOM updates
      if (!this.raf) {
        this.raf = requestAnimationFrame(this.updateBoxStyles);
      }
    }
  }

  init() {
    this.initContainer();
    window.addEventListener("resize", this.initContainer);
    window.addEventListener("mousemove", this.onMouseMove);
  }
}

// Init Highlighter
const highlighters = document.querySelectorAll("[data-highlighter]");
highlighters.forEach((highlighter) => {
  new Highlighter(highlighter);
});
